import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Box } from "@mui/material";
import { CoPresentOutlined, PaymentOutlined, WorkOutlineOutlined } from "@mui/icons-material";

import { PageLayout } from "../../layouts/PageLayout";
import { EmployeeStatement } from "../../components/employee";
import { PageHeader } from "../../components/v3";
import { EmployeeDetails } from "../../components/employee/EmployeeDetails.component";
import { ADD_EMPLOYEE_ATTENDANCE, ADD_EMPLOYEE_INCENTIVE, ADD_EMPLOYEE_SALARY, VIEW_EMPLOYEE_STATEMENT } from "../../constants";
import { useHasPermission } from "../../utils";

export const SingleEmployee = () => {
  const [reload, setReload] = useState(0);

  const { id } = useParams();
  const navigate = useNavigate();

  const hasAddEmployeeSalary = useHasPermission(ADD_EMPLOYEE_SALARY);
  const hasAddEmployeeIncentive = useHasPermission(ADD_EMPLOYEE_INCENTIVE);
  const hasAddEmployeeAttendance = useHasPermission(ADD_EMPLOYEE_ATTENDANCE);
  const hasViewStatement = useHasPermission(VIEW_EMPLOYEE_STATEMENT);

  const handleReload = () => setReload((prev) => prev + 1);

  const buttons = [
    hasAddEmployeeSalary && {
      buttonText: "Add Payment",
      buttonIcon: PaymentOutlined,
      onClick: () => navigate(`/transaction/add?employeeId=${id}`),
    },
    hasAddEmployeeIncentive && {
      buttonText: "Add Incentive",
      buttonIcon: WorkOutlineOutlined,
      onClick: () => navigate("/employee/add-incentive"),
    },
    hasAddEmployeeAttendance && {
      buttonText: "Add Attendance",
      buttonIcon: CoPresentOutlined,
    },
  ];
  return (
    <>
      <PageLayout>
        {/* header section */}
        <Box sx={{ position: "relative", zIndex: 1 }}>
          <PageHeader
            // title
            title="Employee Details"
            // button
            buttons={buttons}
          />
        </Box>

        {/* details */}
        <Box sx={{ mt: -9, zIndex: 2, position: "relative" }}>
          <EmployeeDetails reloadData={reload} />
        </Box>

        {/* table section */}
        {hasViewStatement && <EmployeeStatement showFilterButton onSuccess={handleReload} reloadData={reload} />}
      </PageLayout>
    </>
  );
};
